export default {
  appName: '今日汇率',
  appDesc: '感谢您使用《今日汇率》提供的服务！',
  authorizationTableiOS01: 'iOS 14.5 及以上允许应用跟踪',
  authorizationTableiOS02: '用于提供个性化广告',
  authorizationTableAndroid01: '允许应用程序访问互联网',
  authorizationTableAndroid02: '用于从服务器获取汇率数据',
  authorizationTableAndroid03: '允许应用程序保持清醒',
  authorizationTableAndroid04: '用于防止应用休眠',
  authorizationTableAndroid05: '允许应用程序获取粗略位置信息',
  authorizationTableAndroid06: '用于根据大致位置展示当地货币汇率',
  companyName: '三河智士科技有限公司',
  contactEmail: "support{'@'}ifyyy.cn",
};
